"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M18 10.2h-3.351l3.175-3.176-.848-.848L13.8 9.35V6h-1.2v5.4H18v-1.2zM6 13.8h3.352l-3.176 3.176.848.848L10.2 14.65V18h1.2v-5.4H6v1.2z" }), "Collapse");
//# sourceMappingURL=Collapse.js.map